import { createReducer } from 'reduxsauce';
import { Types } from './actions';

const INITIAL_STATE = {
  loading: false,
  galleryData: null,
  oldGalleryData: null
};

// ************************* Fetch Gallery Data *************************
const fetchGalleryStart = (state = INITIAL_STATE, action) => {
  return { ...state, loading: true };
};

const fetchGallerySuccess = (state = INITIAL_STATE, action) => {
  // console.log('action: ', action);
  return { ...state, galleryData: action.galleryData, loading: false };
};

const fetchGalleryFailure = (state = INITIAL_STATE, action) => {
  return { ...state, loading: false };
};
// _____________________________________________________________________

// ************************* Fetch Old Gallery Data *************************
const fetchOldGalleryStart = (state = INITIAL_STATE, action) => {
  return { ...state, loading: true };
};

const fetchOldGallerySuccess = (state = INITIAL_STATE, action) => {
  // console.log('action: ', action);
  return { ...state, oldGalleryData: action.oldGalleryData, loading: false };
};

const fetchOldGalleryFailure = (state = INITIAL_STATE, action) => {
  return { ...state, loading: false };
};
// _____________________________________________________________________

// Define Handlers
const HANDLERS = {
  [Types.FETCH_GALLERY_START]: fetchGalleryStart,
  [Types.FETCH_GALLERY_FAILURE]: fetchGalleryFailure,
  [Types.FETCH_GALLERY_SUCCESS]: fetchGallerySuccess,
  [Types.FETCH_OLD_GALLERY_START]: fetchOldGalleryStart,
  [Types.FETCH_OLD_GALLERY_FAILURE]: fetchOldGalleryFailure,
  [Types.FETCH_OLD_GALLERY_SUCCESS]: fetchOldGallerySuccess
};

// Create and Export Reducer
export const galleryReducer = createReducer(INITIAL_STATE, HANDLERS);
